module.exports = __webpack_public_path__ + "img/ingredienten-chinese-mapo-tofu-met-kip.a9ffa7a0.jpeg";